import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

import { useKeyboardReorderContext } from '../../../../controllers/keyboard-reorder-provider';

import { messages } from './messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.100'),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export default function ReorderToggle(): React.JSX.Element | null {
	const { formatMessage } = useIntl();

	const {
		isKeyboardReorderModeEnabled,
		setIsKeyboardReorderModeEnabled,
		isKeyboardReorderToggleVisible: isVisible,
		keyboardReorderToggleRef,
		exitKeyboardReorderMode,
		containerRef,
	} = useKeyboardReorderContext();

	if (!isVisible) {
		return null;
	}

	return (
		<Box xcss={styles.container}>
			<Toggle
				id="toggle-reorder-apps"
				testId="toggle-reorder-apps"
				label={formatMessage(messages.ariaReorderLabel)}
				isChecked={isKeyboardReorderModeEnabled}
				ref={keyboardReorderToggleRef}
				onChange={() => setIsKeyboardReorderModeEnabled(!isKeyboardReorderModeEnabled)}
				onBlur={(e) => {
					const isStillInRibbon = containerRef.current?.contains(e.relatedTarget);
					if (!isStillInRibbon) {
						exitKeyboardReorderMode();
					}
				}}
			/>
			<label htmlFor="toggle-reorder-apps">
				<Text maxLines={1} size="small" align="center" color="color.text.disabled">
					{formatMessage(messages.reorderLabel)}
				</Text>
			</label>
		</Box>
	);
}
